export const HR_READ_PERM = 'hr.core:employee:read'
export const HR_WRITE_PERM = 'hr.core:employee:write'
export const HR_DELETE_PERM = 'hr.core:employee:delete'
export const HR_PAYROLL_READ_PERM = 'hr.payroll:payroll:read'
export const HR_PAYROLL_WRITE_PERM = 'hr.payroll:payroll:write'
export const HR_PAYMENT_READ_PERM = 'hr.payroll:payment:read'
export const HR_PAYMENT_WRITE_PERM = 'hr.payroll:payment:write'
export const HR_DOCUMENT_WRITE_PERM = 'documents:catalog:write'
export const HR_LEAVE_WRITE_PERM = 'hr.time:leave:write'
export const HR_ORG_READ_PERM = 'hr.org:department:read'
export const HR_ORG_WRITE_PERM = 'hr.org:department:write'
export const HR_POSITION_READ_PERM = 'hr.org:position:read'
export const HR_POSITION_WRITE_PERM = 'hr.org:position:write'
export const HR_SENSITIVE_READ_PERM = 'hr.core:employee:sensitive_read'
export const HR_COMPENSATION_READ_PERM = 'hr.payroll:compensation:read'
export const HR_COMPENSATION_WRITE_PERM = 'hr.payroll:compensation:write'
export const HR_ALLOWANCE_READ_PERM = 'hr.payroll:allowance:read'
export const HR_OWNER_APPROVE_PERM = 'hr.payroll:owner_approve'
export const HR_LEAVE_READ_PERM = 'hr.time:leave:read'
export const HR_SCHEDULE_READ_PERM = 'hr.time:schedule:read'
export const HR_SCHEDULE_WRITE_PERM = 'hr.time:schedule:write'
export const HR_DOC_CASE_READ_PERM = 'documents:employee:case:read'
export const HR_DOC_MISSING_READ_PERM = 'documents:employee:missing:read'
export const HR_DOCUMENTS_READ_PERM = 'hr.core:documents:read'
export const HR_DOCUMENTS_WRITE_PERM = 'hr.core:documents:write'
export const HR_DOC_CASE_WRITE_PERM = 'documents:employee:case:write'
export const HR_PAYROLL_PARAMS_PERM = 'hr.payroll:params:manage'
